import React, { Component, Fragment } from 'react'
import { Input, Button, Icon } from '@drifthq/tide-core'
import { equals } from 'ramda'
import cx from 'classnames'
import config from 'config'
import { debounce } from 'debounce'

import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
import { OnboardingHeader } from 'components/OnboardingHeader'
import OnboardingBackButton from 'components/OnboardingBackButton'

import './style.css'

const BrandingOptions = {
  LOGO: 'Logo',
  NONE: 'No branding',
  CUSTOM: 'Custom image',
}

const DEBOUNCE_IN_MS = 400

class OnboardingPlaybookCLPUrlStep extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isEnabled: true,
      urlPath: props.landingPageSettings.path || '',
      savingUrlPath: false,
      savedUrlPath: props.landingPageSettings.path || '',
      isEditingUrlPath: true,
      urlPathInputFocused: false,
    }

    this.debouncedSave = debounce(async (settings) => {
      const { playbookId } = this.props
      try {
        this.props.actions.updateCLPSettings({playbookId, settings})
        this.setState({
          isEditingUrlPath: false,
          savingUrlPath: false,
          savedUrlPath: settings.path,
        })
      } catch (e) {
        this.setState({
          isEditingUrlPath: false,
          savingUrlPath: false,
        })
      }
      this.toggleUrlPathInputFocus()
    }, DEBOUNCE_IN_MS)
  }

  doSave = () => {
    const {
      urlPath
    } = this.state

    const brandingOption = BrandingOptions[this.props.landingPageSettings.brandingOption] || BrandingOptions.NONE
    const brandingEnumOption = Object.entries(BrandingOptions).filter((entry) => entry[1] === brandingOption).map((entry) => entry[0])[0]

    this.debouncedSave({
      brandingOption: brandingEnumOption,
      firstGradientColor: this.props.landingPageSettings.firstGradientColor || '#5767e4',
      secondGradientColor: this.props.landingPageSettings.secondGradientColor || '#429CD0',
      path: urlPath,
      customLogo: this.props.landingPageSettings.customLogo,
      status: this.props.landingPageSettings.status,
    })
  }

  onUpdateUrlPath = event => {
    this.setState({
      urlPath: event.target.value
    })
  }

  urlPathIsDirty = () => {
    const { urlPath, savedUrlPath } = this.state
    return !equals(savedUrlPath, urlPath)
  }

  isSaveUrlPathDisabled = () => {
    return !this.state.urlPath || !this.state.urlPath.trim().length
  }

  clearChangesToUrlPath = () => {
    const { savedUrlPath } = this.state
    this.setState({
      urlPath: savedUrlPath,
      isEditingUrlPath: false,
    })
  }

  toggleUrlPathInputFocus = async () => {
    this.setState(prevState => ({
      urlPathInputFocused: !prevState.urlPathInputFocused
    }))
  }

  doSaveFromPath = async () => {
    this.doSave()
    this.setState({
      savingUrlPath: true,
    })
  }

  toggleEditingUrlPath = () => {
    this.setState(prevState => ({
      isEditingUrlPath: !prevState.isEditingUrlPath,
    }))
  }

  render() {
    const {
      landingPageSubdomain,
      landingPageCname,
      onContinue,
      stepCount,
      index
    } = this.props

    const {
      urlPath,
      savingUrlPath,
      urlPathInputFocused,
      savedUrlPath,
      isEditingUrlPath,
    } = this.state

    const landingPageDomain = landingPageCname || `${landingPageSubdomain}.${config.PAGES_HOST}`

    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
        <OnboardingHeader
          title="Create a custom URL for your landing page"
          description="You can always change this later!"
        />
        <div className="playbook-editor-content-area-bot-page">
          <div className="playbook-editor-content-area-bot-page-inner">
            <div className="onboarding-playbook-clp--custom-url">
              <span>
                {!isEditingUrlPath &&
                  <Fragment>
                    <a target="_blank" rel="noopener noreferrer" href={`https://${landingPageDomain}/t/${savedUrlPath}`}>https://{landingPageDomain}/t/{savedUrlPath}</a>
                    <span className="onboarding-playbook-clp--custom-url-edit-icon" onClick={this.toggleEditingUrlPath}><Icon name="pencil" width="18" height="18" /></span>
                  </Fragment>
                }
              </span>
              {isEditingUrlPath &&
                <Fragment>
                  <span className="onboarding-playbook-clp--url-base">{`https://${landingPageDomain}/t/`}</span>
                  <div className="onboarding-playbook-clp--custom-url-input-container">
                    <Input
                      size="large"
                      value={urlPath}
                      onFocus={this.toggleUrlPathInputFocus}
                      onBlur={this.toggleUrlPathInputFocus}
                      onChange={this.onUpdateUrlPath}
                      placeholder="my-bot-page"
                      required
                      className={cx("onboarding-playbook-clp--slug-input", {
                        "is-focused": savingUrlPath || urlPathInputFocused || this.urlPathIsDirty()
                      })}
                    />
                    <div
                      className={cx("onboarding-playbook-clp--custom-url-actions", {
                        "is-focused": savingUrlPath || urlPathInputFocused || this.urlPathIsDirty()
                      })}>
                      <Button disabled={this.isSaveUrlPathDisabled()} size="medium" loading={savingUrlPath} className="header-control-check" onClick={this.doSaveFromPath} ><Icon width={12} name="check" /></Button>
                      <Button type="secondary" className="header-control-close" size="medium" onClick={this.clearChangesToUrlPath}><Icon name="close" /></Button>
                    </div>
                  </div>
                </Fragment>
              }
            </div>
          </div>
        </div>
        <Button disabled={!savedUrlPath} className="onboarding-playbook-clp--next-button" size="large" onClick={onContinue}>
          Build my bot!
        </Button>
        <OnboardingBackButton />
      </Fragment>
    )
  }
}

export default OnboardingPlaybookCLPUrlStep


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookCLPUrlStep/index.js